<template>
  <section>
    <ul class="filters-list">
      <li>
        <router-link :to="{ name: 'AllPendingBilledCases', query: $route.query }">
          Unbilled
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'BilledCases', query: $route.query }">
          Billed
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'BilledExceptionBilledCases', query: $route.query }" title="Billed with Exception">
          BWE
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'CodingCases', query: $route.query }">
          Coding
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'ClientBilledCases', query: $route.query }">
          Client
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>

      <!-- Exception Dropdown -->
      <li class="dropdown">
        <span class="dropdown-trigger">
          {{ selectedException.label }}
          <img style="margin-left: 2px;" src="@/assets/images/caret-down-fill.svg" alt="" />
        </span>
        <ul class="dropdown-menu">
          <li v-for="(option, index) in exceptionOptions" :key="index">
            <router-link :to="{ name: option.route, query: $route.query }" @click="selectException(option)">
              {{ option.label }}
            </router-link>
          </li>
        </ul>
      </li>

      <li>
        <router-link :to="{ name: 'OnholdBilledCases', query: $route.query }">
          On hold
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'BilledPatientBilledCases', query: $route.query }">
          Patient
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'MileageCases', query: $route.query }">
          Mileage
          <span class="active-icon"><img src="@/assets/images/caret-down-fill.svg" alt="" /></span>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {
      selectedException: { label: "Exception", route: "ExceptionBilledCases" },
      exceptionOptions: [
        { label: "Exception", route: "ExceptionBilledCases" },
        { label: "Exception Reviewed", route: "ExceptionReviewedCases" },
        { label: "Exception Resolved", route: "ExceptionResolvedCases" }
      ]
    };
  },
  methods: {
    selectException(option) {
      this.selectedException = option;
    }
  }
};
</script>

<style scoped>
/* Dropdown styling */
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0px 5px;
  font-size: 14px;
}

.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  list-style: none;
  padding: 5px 0;
  min-width: 150px;
  z-index: 100;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-menu li {
  padding: 2px 15px;
  white-space: nowrap;
}

.dropdown-menu li:hover {
  background: #f5f5f5;
}
</style>
